<template>
    <div>
      <div class="row">
        <div class="col-12">
          <h4>License</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p>
            G2 Communicator by Galaxy Next Generation (G2) is offered as a pre-installed appliance and/or virtual machine.  Either version requires a license key provided by Galaxy Next Generation (G2) to the G2 Communicator certified dealer or end user.
          </p>
          <p>
            All Licenses keys are assigned to a single physical machine or virtual machine.  Each key is also registered to the school and district where the product will be installed.  G2 Communicator is not transferable.
          </p>
          <p>
            No version of G2 Communicator software, appliances and virtual machines may be distributed without written consent and contract with Galaxy Next Generation (G2). Any distribution of patches or unapproved versions is prohibited.
          </p>
          <p>
            G2 Communicator appliances and virtual machines require access to the internet to allow the appliance and/or virtual machine to communicate with the licensing server.
          </p>
          <p>
            G2 Communicator includes on-line links to internet sites, Galaxy Next Generation (G2) does not guarantee links within G2 Communicator will be active at any time.
          </p>
          <p>
            Galaxy Next Generation (G2) and its resellers are not liable for any damages that may occur as the result of using G2 Communicator.  These damages include, but are not restricted to, work stoppage, computer failure or malfunction, and loss of goodwill.
          </p>
          <p>
            Galaxy Next Generation (G2) reserves the right to update this End User License Agreement at any time.
          </p>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'license'
}
</script>

<style scoped>

</style>
